import { SessionsTable } from "@/components/v2/account/SessionsTable";
import { SettingsSection } from "@/components/v2/account/SettingsSection";

/** `/account/sessions` — devices + browsers signed into the account. */
export function AccountSessions() {
  return (
    <SettingsSection
      title="Active sessions"
      description="Devices and browsers currently signed into your account. Revoke any you don't recognize."
    >
      <SessionsTable />
    </SettingsSection>
  );
}
